import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import user from './modules/user.js'
import getters from './getters'
import permission from './modules/permission'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    list: [],
    no_time: true,
    keepList: ''
  },
  mutations: {
    initList(state, list) {
      state.list = list
    },
    setKeep(state, val) {
      state.keepList = val
    },
    set_no_time(state) {
      state.no_time = false
    }
  },
  actions: {
    getMenuList(context) {
      axios.get('./menu.json').then(({ data }) => {
        context.commit('initList', data)
      })
    }
  },
  getters,
  modules: {
    user,
    permission
  }
})
